import React, { useState } from "react";
import { withCookies } from "react-cookie";
import { Button } from 'primereact/button';
import { Auth } from "aws-amplify";
import { isNil } from "lodash";
import { useNavigate } from "react-router-dom";
import { LoginType } from "./LoginType";
// https://adebola-niran.medium.com/react-loading-screen-while-a-user-is-logging-in-3-steps-bb537031d1d4
import { conv_groups_array_for_state } from '../../helpers/AccessHelper';
import axiosWithAuth from '../../helpers/AxiosHelper';
import errorMessage from '../../helpers/errorMessage';
import Exaport from "../../assets/images/exaport.png";
import AuthLayout from "./AuthLayout";
import "./login.css";
import { useAuth } from "../../hooks/useAuth";

function LogIn(props) {

  const { token, login, logout } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm_password, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [user_aws, setUserAWS] = useState(null);
  const [login_type, setLoginType] = useState(LoginType.LOGIN);
  const [code, setCode] = useState('');
  const [code_button_text, setCodeButtonText] = useState('Send Code');
  const [username_error, setUsernameError] = useState('');
  const [password_error, setPasswordError] = useState('');
  const [confirm_password_error, setConfirmPasswordError] = useState('');

  function handleChange(e) {
    let nam = e.target.name;
    let val = e.target.value;
    switch (nam) {
      case 'username':
        setUsername(val)
        break;
      case 'password':
        setPassword(val)
        break;
      case 'confirm_password':
        if (login_type === LoginType.FORCE_CHANGE_PASSWORD || login_type === LoginType.FORGOT_PASSWORD) {
          if (password !== val) {
            setError('Passwords do not match.')
          } else {
            setError('')
          }
        }
        setConfirmPassword(val)
        break;
      case 'error':
        setError(val)
        break;
      case 'code':
        setCode(val)
        break;
      default:
        break;
    }
  };

  async function login_func(e) {
    e.preventDefault();
    setSuccess('');
    if (validateForm()) {
      props.setLoading(true);
      let data = {
        username: username,
        password: password
      }
      try {
        await Auth.signIn(data.username, data.password)
          .then(user => {
            setUserAWS(user)
            if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
              change_login_type(LoginType.FORCE_CHANGE_PASSWORD)
              return;
            }

            if (!user['attributes']['custom:Platform']) {
              setError('Originator not set. Kindly ask Admin to set Originator.')
              Auth.signOut().then(val => {
                props.setLoading(false);
                logout();
              });
              return;
            }
            if (!user['signInUserSession']['idToken']['payload']['cognito:groups']) {
              setError('No groups set. Kindly ask Admin to set Group.')
              Auth.signOut().then(val => {
                props.setLoading(false);
                logout();
              });
              return;
            }
            const get_config = axiosWithAuth.get("/platforms/config", { params: { platform: user['attributes']['custom:Platform'] } })

            get_config.then((data) => {
              props.setLoading(false);
              props.setGroups(conv_groups_array_for_state(user['signInUserSession']['idToken']['payload']['cognito:groups']))
              login(user['signInUserSession']['idToken']['jwtToken'],
                user['attributes']['email'],
                conv_groups_array_for_state(user['signInUserSession']['idToken']['payload']['cognito:groups']),
                user['attributes']['custom:Platform'],
                data.data[0]);
            }).catch(err => { logout(); props.setLoading(false); setError(errorMessage(err)); })
          })
          .catch(err => { props.setLoading(false); setError(err.message); })
      } catch (error) {
        props.setLoading(false);
        setError(error.message)
      }
    }
  };

  async function changePassword(e) {
    e.preventDefault();
    props.setLoading(true);
    setError('');
    setSuccess('');
    if (!password) {
      setError("*Please enter your password.");
      props.setLoading(false);
      return;
    }
    if (password !== confirm_password) {
      setError('Passwords do not match.');
      props.setLoading(false);
      return;
    }
    const { cookies } = props;
    try {
      await Auth.completeNewPassword(user_aws, password, { email: username })
        .then(user => {
          change_login_type(LoginType.LOGIN);
          setUsername(username);
          setSuccess('Password Changed')
          props.setLoading(false);
        })
        .catch(err => { props.setLoading(false); setError(err.message); })
    } catch (error) {
      setError(error.message)
      props.setLoading(false);
    }
  }

  function handleSubmit(input) {
    input.preventDefault();

  };

  function validateForm() {
    let formIsValid = true;

    if (!username) {
      formIsValid = false;
      setError("*Please enter your Email.");
    }
    else if (!isNil(username)) {
      //regular expression for email validation
      var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(username)) {
        formIsValid = false;
        setError("*Please enter valid email Address.");
      }
    }
    else if (!password) {
      formIsValid = false;
      setError("*Please enter your password.");
    }
    if (formIsValid)
      setError('');
    return formIsValid;
  }

  function change_login_type(login_type_to_change_to) {
    props.setLoading(true);
    switch (login_type_to_change_to) {
      case LoginType.LOGIN:
        setUsername('');
        setPassword('');
        setError('');
        break;
      case LoginType.FORGOT_PASSWORD:
        setPassword('');
        setError('');
        break;
      case LoginType.FORCE_CHANGE_PASSWORD:
        setPassword('');
        break;
    }
    setLoginType(login_type_to_change_to)
    props.setLoading(false);
  }

  async function send_forgot_password_code(e) {
    if (!username) {
      setError("*Please enter your Email.");
      return;
    }

    Auth.forgotPassword(username)
      .catch(err => { setError(err.message); });

  };

  async function forgot_password(e) {
    e.preventDefault();
    props.setLoading(true);
    setError('');
    let error_msg = ""
    let formIsValid = true;
    if (!username) {
      formIsValid = false;
      error_msg = "*Please enter your username.";
      return;
    }
    else if (!password) {
      formIsValid = false;
      error_msg = "*Please enter your password.";
    }
    else if (password != confirm_password) {
      formIsValid = false;
      error_msg = 'Passwords do not match.';
    }
    else if (!code) {
      formIsValid = false;
      error_msg = "*Please enter the code received on your email.";
    }
    if (!formIsValid) {
      setError(error_msg);
      props.setLoading(false);
      return;
    }

    await Auth.forgotPasswordSubmit(username, code, password)
      .then(() => {
        change_login_type(LoginType.LOGIN);
        return;
      })
      .catch(err => { setError(err.message); });
  };


  if (login_type == LoginType.LOGIN)
    return (
      <AuthLayout>
        <div id="container" className="auth-card">
          <img alt="ExaPort" className="auth-card-logo" src={Exaport} />
          <h1 className="auth-title">Welcome back</h1>
          <p className="auth-subtitle">Log in to your account</p>
          <div name='error' className="errorMsg auth-alert">{error}</div>
          <div name='success' className="successMsg auth-alert">{success}</div>
          <form method="post" name="userRegistrationForm" onSubmit={login_func} className="auth-form">
            <label className="auth-field">
              <span className="auth-label">Email</span>
              <span className="auth-input-wrap">
                <i className="pi pi-envelope" />
                <input name='username' className="auth-input" type="text" placeholder="Username" autoComplete="username" value={username} onChange={handleChange} />
              </span>
            </label>
            <div name='username_error' className="errorMsg">{username_error}</div>
            <label className="auth-field">
              <span className="auth-label">Password</span>
              <span className="auth-input-wrap">
                <i className="pi pi-lock" />
                <input name='password' className="auth-input" type="password" placeholder="Password" autoComplete="current-password" value={password} onChange={handleChange} />
              </span>
            </label>
            <div name='password_error' className="errorMsg">{password_error}</div>

            <Button label="Login" type="submit" icon="pi pi-arrow-right" iconPos="right" className="auth-submit" />
          </form>
          <Button label="Forgot Password" className="p-button-text auth-secondary" onClick={() => {
            change_login_type(LoginType.FORGOT_PASSWORD)
          }} />
        </div>
      </AuthLayout>
    );
  if (login_type == LoginType.FORCE_CHANGE_PASSWORD)
    return (
      <AuthLayout>
        <div id="container" className="auth-card">
          <img alt="ExaPort" className="auth-card-logo" src={Exaport} />
          <h1 className="auth-title">Set a new password</h1>
          <p className="auth-subtitle">Please change Password.</p>
          <div name='error' className="errorMsg auth-alert">{error}</div>
          <form method="post" name="userRegistrationForm" onSubmit={changePassword} className="auth-form">
            <label className="auth-field">
              <span className="auth-label">Email</span>
              <span className="auth-input-wrap is-readonly">
                <i className="pi pi-envelope" />
                <input name='username' className="auth-input" type="text" placeholder="Username" value={username} onChange={handleChange} readOnly={true} />
              </span>
            </label>
            <div name='username_error' className="errorMsg">{username_error}</div>
            <label className="auth-field">
              <span className="auth-label">New password</span>
              <span className="auth-input-wrap">
                <i className="pi pi-lock" />
                <input name='password' className="auth-input" type="password" placeholder="New Password" autoComplete="new-password" value={password} onChange={handleChange} />
              </span>
            </label>
            <div name='password_error' className="errorMsg">{password_error}</div>
            <label className="auth-field">
              <span className="auth-label">Confirm password</span>
              <span className="auth-input-wrap">
                <i className="pi pi-lock" />
                <input name='confirm_password' className="auth-input" type="password" placeholder="Confirm Password" autoComplete="new-password" value={confirm_password} onChange={handleChange} />
              </span>
            </label>
            <div name='confirm_password_error' className="errorMsg">{confirm_password_error}</div>
            <div className="auth-actions">
              <Button label="Cancel" className="p-button-outlined" onClick={() => {
                change_login_type(LoginType.LOGIN)
              }} />

              <Button label="Confirm" type="submit" />
            </div>
          </form>
        </div>
      </AuthLayout>
    );
  if (login_type == LoginType.FORGOT_PASSWORD)
    return (
      <AuthLayout>
        <div id="container" className="auth-card">
          <img alt="ExaPort" className="auth-card-logo" src={Exaport} />
          <h1 className="auth-title">Reset your password</h1>
          <p className="auth-subtitle">Please Enter New Password And Code</p>
          <div name='error' className="errorMsg auth-alert">{error}</div>
          <div className="auth-code-step">
            <span className="auth-step-badge">1</span>
            <div className="auth-code-step-body">
              <p>To send code please click on the button below</p>
              <Button variant="text" className="p-button-outlined p-button-sm" icon="pi pi-send" onClick={() => { send_forgot_password_code() }}>{code_button_text}</Button>
            </div>
          </div>
          <form method="post" name="userRegistrationForm" onSubmit={forgot_password} className="auth-form">
            <label className="auth-field">
              <span className="auth-label">Email</span>
              <span className="auth-input-wrap">
                <i className="pi pi-envelope" />
                <input name='username' className="auth-input" type="text" placeholder="Username" autoComplete="username" value={username} onChange={handleChange} />
              </span>
            </label>
            <div name='username_error' className="errorMsg">{username_error}</div>
            <label className="auth-field">
              <span className="auth-label">New password</span>
              <span className="auth-input-wrap">
                <i className="pi pi-lock" />
                <input name='password' className="auth-input" type="password" placeholder="New Password" autoComplete="new-password" value={password} onChange={handleChange} />
              </span>
            </label>
            <div name='password_error' className="errorMsg">{password_error}</div>
            <label className="auth-field">
              <span className="auth-label">Confirm password</span>
              <span className="auth-input-wrap">
                <i className="pi pi-lock" />
                <input name='confirm_password' className="auth-input" type="password" placeholder="Confirm Password" autoComplete="new-password" value={confirm_password} onChange={handleChange} />
              </span>
            </label>
            <div name='confirm_password_error' className="errorMsg">{confirm_password_error}</div>
            <label className="auth-field">
              <span className="auth-label">Verification code</span>
              <span className="auth-input-wrap">
                <i className="pi pi-key" />
                <input name='code' className="auth-input" type="number" placeholder="Enter Code" autoComplete="one-time-code" value={code} onChange={handleChange} />
              </span>
            </label>
            <div className="auth-actions">
              <Button label="Cancel" className="p-button-outlined" onClick={() => {
                change_login_type(LoginType.LOGIN)
              }} />

              <Button label="Confirm" type="submit" />
            </div>
          </form>
        </div>
      </AuthLayout>
    );
}

export default withCookies(LogIn);
